'use client';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../../../utils/setDenaliAttribute';
import { ContainerBadgeProps } from '../types';
import styles from './PeakContainerBadge.module.scss';

// https://www.figma.com/design/9Y1n3VoMJAcTGPe82bvySj/Denali-Components?node-id=17663-10035&t=Wc0QUQo5g3baINAQ-0
const PeakContainerBadge = ({ className, size = 'md' }: ContainerBadgeProps) => {
  const intl = useIntl();

  return (
    <span
      {...setDenaliAttribute('SubscriptionBadge')}
      aria-label={intl.formatMessage({ defaultMessage: '{tier} badge image' }, { tier: 'Peak' })}
      className={classNames(styles.root, styles[size], className)}
      role="img"
    >
      <span aria-hidden className={styles.icon} />
      <span aria-hidden className={styles.wordmark} />
    </span>
  );
};

export default PeakContainerBadge;
